// extracted by mini-css-extract-plugin
export default {"container":"UserChangePasswordTab_container__5HPwC","textTitle":"UserChangePasswordTab_textTitle__yDIyp"};